import type { SelectionChipToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useSelectionChipTokens = (theme: Theme): SelectionChipToken => {
  const { color, borderRadius, component } = theme;
  const base = {
    active: color.primary,
    borderRadius: borderRadius.md,
    background: {
      active: color.primaryVariant,
      default: color.surfaceContainerVariant,
      hover: color.onSurface,
    },
    text: {
      active: color.onSurface,
      default: color.onSurface,
      hover: color.onSurface,
    },
  };

  return merge({}, base, component?.selectionChip) as SelectionChipToken;
};
